import WorkGroup from "../../../pages/WorkGroup";
import {getPXLWorkGroupRoute} from "./factory/workGroup";

/**
 * React Router v7 doesn't use 'exact' prop anymore.
 * Routes by default match 'exactly' unless there is a * or a splat parameter in the path.
 * For more details, see the React Router v7 documentation.
 */
const routes = [
    {
        path: getPXLWorkGroupRoute(),
        component: WorkGroup,
        type: 'route',
        loginRequired: true,
    },
];

export default routes;